import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=39db5628&scoped=true"
import script from "./ClientInformation.vue?vue&type=script&lang=js"
export * from "./ClientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db5628",
  null
  
)

export default component.exports